import { FC } from "react";
import cx from "classnames";
import "styles/button.scss";
import Loader from "components/atoms/EllipsisLoader";
import { ButtonProps } from "types/atoms.types";

const Button: FC<ButtonProps> = ({
  label,
  disabled,
  type,
  onClick,
  loading,
}) => {
  const btnCls = cx("asr-btn", `asr-btn__${type}`, { loading: loading });
  return (
    <button disabled={disabled} className={btnCls} onClick={onClick}>
      {loading ? <Loader color={type === "ghost" ? "dark" : "light"} /> : label}
    </button>
  );
};

export default Button;
